<div class="auth-layout">
  <div class="auth-content">
    <router-outlet></router-outlet>
  </div>
</div>
